import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { InputGroup, ListGroup } from "react-bootstrap";
import { Search, X } from "react-bootstrap-icons";
import React, { useState } from "react";
import * as PropTypes from "prop-types";

export function PlayerSearch({ value, typeaheadResults, setTypeaheadInput }) {
    const [showTypeAheadResults, setShowTypeAheadResults] = useState(false)
    const onTypeaheadChange = (e) => {
        const nameValue = e.target.value
        setShowTypeAheadResults(true)
        setTypeaheadInput(nameValue || '')
    };
    const onResultClick = (p) => (() => {
        setTypeaheadInput(p.name)
        setShowTypeAheadResults(false)
    });
    const onResultClearClick = () => {
        setTypeaheadInput("")
    }

    return <Row className="player-search mb-3 mt-3">
        <Col>
            <Form.Group>
                <InputGroup>
                    <InputGroup.Text><Search/></InputGroup.Text>
                    <Form.Control
                        type="text"
                        onChange={onTypeaheadChange}
                        placeholder="search for a player..."
                        value={value}
                    />
                    {value.length > 0 &&
                        <InputGroup.Text onClick={onResultClearClick}><X/></InputGroup.Text>}
                </InputGroup>
                <ListGroup>
                    {showTypeAheadResults
                        ? typeaheadResults.map(p => (
                            <ListGroup.Item key={p.id} onClick={onResultClick(p)}>
                                {p.name}
                            </ListGroup.Item>
                        ))
                        : null
                    }
                </ListGroup>
            </Form.Group>
        </Col>
    </Row>;
}

PlayerSearch.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    onClick: PropTypes.func,
    showTypeAheadResults: PropTypes.bool,
    typeaheadResults: PropTypes.arrayOf(PropTypes.any),
    callbackFn: PropTypes.func
};
